import { FetchImportExportHistoriesArgs } from '@/context/services/import_export_histories/ImportExportHistories.service';
import { IMPORT_EXPORT_HISTORIES_PER_PAGE } from '@/features/import_export_histories/constants';
import {
  isValidSortBy,
  isValidSource,
  isValidType,
} from '@/features/import_export_histories/utils/typeGuards';
import { useUpdateURLSearchParams } from '@/hooks/useConvertToURLSearchParams';
import { useQueryParams } from '@/hooks/useQueryParams';
import { useCallback } from 'react';

export const useImportExportHistoriesSearchQueryInitial = (
  searchParams: URLSearchParams
): FetchImportExportHistoriesArgs => {
  const { getArrayParam } = useQueryParams();

  const typeParam = searchParams.get('type');
  const sourceParam = searchParams.get('source');
  const officeMemberIdsParam = getArrayParam(searchParams, 'office_member_ids');
  const sortByParam = searchParams.get('sort_by');
  const pageNum = Number(searchParams.get('page'));

  return {
    type: typeParam && isValidType(typeParam) ? typeParam : undefined,
    source: sourceParam && isValidSource(sourceParam) ? sourceParam : undefined,
    office_member_ids: officeMemberIdsParam?.length
      ? officeMemberIdsParam
      : undefined,
    submitted_at_from: searchParams.get('submitted_at_from') || undefined,
    submitted_at_to: searchParams.get('submitted_at_to') || undefined,
    sort_by: isValidSortBy(sortByParam) ? sortByParam : undefined,
    page: Number.isInteger(pageNum) && pageNum >= 1 ? pageNum : 1,
    per: IMPORT_EXPORT_HISTORIES_PER_PAGE,
  };
};

export const useImportExportHistoriesSearchQuery = () => {
  const updateSearchParams = useUpdateURLSearchParams();

  const handleSearch = useCallback(
    (query: FetchImportExportHistoriesArgs) => {
      updateSearchParams(query);
    },
    [updateSearchParams]
  );

  return { handleSearch };
};
